import axios from 'axios';
import {axiosConfig as config} from 'config/axiosConfig';

const {REACT_APP_API} = process.env;
const baseUrl = `${REACT_APP_API}/warehouses`;


export const getAll = async ({page = '', limit = '', code = '', name = ''}) => {
 const {data} = await axios.get(`${baseUrl}/?page=${page}&limit=${limit}&code=${code}&name=${name}`, config)
 return data
}

export const create = async ({warehouse = {}}) => {
 const {data} = await axios.post(baseUrl, warehouse, config)
 return data
}

export const update = async ({warehouse = {}, id}) => {
 const {data} = await axios.put(`${baseUrl}/${id}`, warehouse, config)
 return data
}

export const del = async ({id}) => {
 const {data} = await axios.delete(`${baseUrl}/${id}`, config)
 return data
}